import React from 'react';
import { FieldErrorMessage } from '@app.shared/Style/Forms';

export const FieldValidationMessage = ({ errors, touched, name }) => {
  return <>{errors[name] && touched[name] ? <FieldErrorMessage>{errors[name]}</FieldErrorMessage> : null}</>;
};
